function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { isOrderMoreWarningRemovePopupShownSelector, isOrderMoreWarningEditPopupShownSelector, isOrderMoreWarningEditQuantityPopupShownSelector, popupParamsSelector, isOrderMoreWarningEditBoxPopupShownSelector, isOrderMoreWarningAddProductsPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { rebuildItem, removeItemFromCart, removeItemFromDraft } from 'swag-client-common/redux/cart/cart.actions';
import { BOX_BUILDER_SELECT_PRODUCTS_DRAWER, CART_BOX_BUILDER_POPUP, EDIT_BOX_NOTECARD_POPUP } from 'swag-client-common/constants';
import { hidePopup, showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { OrderStorageTypes } from 'swag-common/constants/main-swag.constants';
import { isItemBoxSpecialNotecard } from 'swag-common/utils/order/item-is-box.util';
import { isItemInDraftSelector } from '../../../redux/cart/cart.selectors';
import { setBoxBuilderEditModeBoxItemsId, setEditingBoxTypeBoxId, startEditBoxQuantity } from '../../../redux/box-builder/box-builder.actions';
import { getAddonProductsForBox } from '../../../redux/product/product.actions';
import { setBoxNotecardBuilderBoxItemsId } from '../../../redux/box-notecard-editor/box-notecard-editor.actions';
import { OrderMoreChangesWarningPopup } from './order-more-changes-warning-popup';
const commonSelector = {
  params: popupParamsSelector,
  isDraft: isItemInDraftSelector,
  message: createSelector(popupParamsSelector, ({
    item
  }) => item !== null && item !== void 0 && item.boxItemsId ? 'You already have this box in your inventory, changing products in the box will lead to the creation of a new box in your swag closet. Would you like to proceed?' : 'You already have this product in your inventory, changing it will lead to the creation of a new product in your swag closet. Would you like to proceed?')
};
const deleteMapStateToProps = createStructuredSelector(_objectSpread({}, commonSelector, {
  open: isOrderMoreWarningRemovePopupShownSelector
}));
const deleteMapDispatchToProps = dispatch => ({
  onConfirm: (item, storageType, itemIdFromReorder) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    storageType === OrderStorageTypes.DRAFT ? dispatch(removeItemFromDraft({
      id: item._id,
      itemIdFromReorder,
      isRemoveFromBox: true
    })) : dispatch(removeItemFromCart({
      id: item._id,
      isRemoveFromBox: true
    }));
    dispatch(hidePopup());
  },
  onClose: () => {
    dispatch(hidePopup());
  }
});
const editMapStateToProps = createStructuredSelector(_objectSpread({}, commonSelector, {
  open: isOrderMoreWarningEditPopupShownSelector
}));
const editMapDispatchToProps = dispatch => ({
  onConfirm: (item, storageType) => {
    dispatch(hidePopup());
    if (isItemBoxSpecialNotecard(item)) {
      dispatch(setBoxNotecardBuilderBoxItemsId((item === null || item === void 0 ? void 0 : item.boxItemsId) || ''));
      dispatch(showPopup({
        popup: EDIT_BOX_NOTECARD_POPUP
      }));
    } else {
      dispatch(rebuildItem(item, storageType));
    }
  },
  onClose: () => {
    dispatch(hidePopup());
  }
});
const editQuantityMapStateToProps = createStructuredSelector(_objectSpread({}, commonSelector, {
  open: isOrderMoreWarningEditQuantityPopupShownSelector
}));
const editBoxMapStateToProps = createStructuredSelector(_objectSpread({}, commonSelector, {
  open: isOrderMoreWarningEditBoxPopupShownSelector
}));
const addProductsMapStateToProps = createStructuredSelector(_objectSpread({}, commonSelector, {
  open: isOrderMoreWarningAddProductsPopupShownSelector
}));
const editQuantityMapDispatchToProps = dispatch => ({
  onConfirm: item => {
    dispatch(startEditBoxQuantity(item === null || item === void 0 ? void 0 : item._id));
  },
  onClose: () => {
    dispatch(hidePopup());
  }
});
const editBoxMapDispatchToProps = dispatch => ({
  onConfirm: item => {
    dispatch(setEditingBoxTypeBoxId(item._id));
    dispatch(showPopup({
      popup: CART_BOX_BUILDER_POPUP
    }));
  },
  onClose: () => {
    dispatch(hidePopup());
  }
});
const addProductsMapDispatchToProps = dispatch => ({
  onConfirm: item => {
    dispatch(getAddonProductsForBox());
    dispatch(setBoxBuilderEditModeBoxItemsId(String(item._id)));
    dispatch(showPopup({
      popup: BOX_BUILDER_SELECT_PRODUCTS_DRAWER
    }));
  },
  onClose: () => {
    dispatch(hidePopup());
  }
});
export const OrderMoreAddProductsWarningPopup = connect(addProductsMapStateToProps, addProductsMapDispatchToProps)(OrderMoreChangesWarningPopup);
export const OrderMoreEditBoxWarningPopup = connect(editBoxMapStateToProps, editBoxMapDispatchToProps)(OrderMoreChangesWarningPopup);
export const OrderMoreDeleteWarningPopup = connect(deleteMapStateToProps, deleteMapDispatchToProps)(OrderMoreChangesWarningPopup);
export const OrderMoreEditWarningPopup = connect(editMapStateToProps, editMapDispatchToProps)(OrderMoreChangesWarningPopup);
export const OrderMoreEditQuantityWarningPopup = connect(editQuantityMapStateToProps, editQuantityMapDispatchToProps)(OrderMoreChangesWarningPopup);